'use client'
import { useState, useEffect } from 'react'
import Image from "next/image"
import { Listbox } from "@headlessui/react"
import { useRouter } from 'next/navigation'
import { getSearchParams, removeSearchParam, updateDistrictsParams } from "@utils";
import { RiArrowDropDownLine } from 'react-icons/ri'
import tailwindConfig from '@tailwind.config'
import { Popover } from '@headlessui/react'



const MultiDistrictFilter = ({ title, dictionary, districtList }) => {
    const router = useRouter();

    const [query, setQuery] = useState('');
    const [selectedDistricts, setSelectedDistricts] = useState([]);
    const [selectedValues, setSelectedValues] = useState([])
    const [selectedLocations, setSelectedLocations] = useState([])

    const handleCheckboxChange = (district) => {
        const updatedSelectedDistricts = selectedDistricts.includes(district)
            ? selectedDistricts.filter((selected) => selected !== district)
            : [...selectedDistricts, district];
        // console.log(updatedSelectedDistricts)
        setSelectedDistricts(updatedSelectedDistricts);
        // console.log(selectedDistricts)
        // Update the router or perform any other actions as needed
        // For example, you might want to update the query parameter in the URL
        const newPathName = updatedSelectedDistricts.length > 0
            ? updateDistrictsParams(updatedSelectedDistricts.join(','))  // Assuming updateDistrictsParams takes a comma-separated list
            : removeSearchParam(title);

            
            router.push(newPathName);
            router.refresh();
            
    };

    useEffect(() => {
        const districtsValue = getSearchParams('districts')
        // console.log(districtsValue)
        // const newValue = districtList.find(obj => obj.id === districtsValue);
        // console.log('new value ' + newValue)
        if (districtsValue?.length > 0) {
            let newValue = districtsValue.split(',')
            setSelectedDistricts(newValue)
            setSelectedValues(newValue)
        } else {
            setSelectedDistricts([])
            setSelectedValues([])
        }

    }, [])

    const selectCheckedValues = () => {
        const districtsValue = getSearchParams('districts')
        if (districtsValue?.length > 0) {
            setSelectedValues(districtsValue)
        } else {
            setSelectedValues([])
        }
    }

    const selectWholeArea = (areaName) => {

        // console.log('curentyl selecred values')
        // console.log(currentlySelectedValues)
        if (!selectedLocations.includes(areaName)) {
            let districtParams = getSearchParams('districts')?.split(',') || []

            let currentlySelectedValues = Array.isArray(districtParams) ? districtParams : [districtParams];
            const selectedDistrictList = districtList
                .filter(dist => dist.location === areaName)
                .map(dist => dist.id);
    
            // console.log(selectedDistrictList)
    
                let newSelectedValues = currentlySelectedValues

                selectedDistrictList.forEach(districtId => {
                    if (!currentlySelectedValues.includes(districtId)) {
                        newSelectedValues.push(districtId)
                    }
                });

                setSelectedDistricts(newSelectedValues)
                setSelectedValues(newSelectedValues)
                setSelectedLocations([...selectedLocations, areaName])

                // console.log(newSelectedValues)

                const newPathName = newSelectedValues.length > 0
                ? updateDistrictsParams(newSelectedValues.join(','))  // Assuming updateDistrictsParams takes a comma-separated list
                : removeSearchParam(title);
        
                router.push(newPathName);
                router.refresh();
        } else {
            let districtParams = getSearchParams('districts')?.split(',') || []

            let currentlySelectedValues = Array.isArray(districtParams) ? districtParams : [districtParams];
            const newLocationArray = selectedLocations.filter(item => item !== areaName);
            
            
            const areaDistricts = districtList                
            .filter(dist => dist.location == areaName)
            .map(dist => dist.id);
            
            let newSelectedValues = []
            
            currentlySelectedValues.forEach((dist) => {
                if (!areaDistricts.includes(dist)) {
                    newSelectedValues.push(dist)
                }
            })

            setSelectedLocations(newLocationArray)
            setSelectedDistricts(newSelectedValues)
            setSelectedValues(newSelectedValues)
            
            
            const newPathName = newSelectedValues.length > 0
            ? updateDistrictsParams(newSelectedValues.join(','))  // Assuming updateDistrictsParams takes a comma-separated list
            : removeSearchParam(title);
    
            router.push(newPathName);
            router.refresh();

        }

        // console.log(selectedDistrictList)
    }

    useEffect(() => {
        // console.log(selectedLocations)
    }, [selectWholeArea])

    const showAreas = () => {
        const districtsValue = getSearchParams('districts')
        if (districtsValue?.length > 0) {
            const distList = districtsValue.split(',')
            const stringArray = []
            districtList.map((district) => {
                if (distList.includes(district.id)) {
                    stringArray.push(district.subdistrict)
                }
            })
            const multipleString = stringArray.toString().replaceAll(',', ', ')
            return multipleString
        } else {
            return 'All Areas'
        }
    }

    const filteredDistrict =
        query === ''
            ? districtList
            : districtList.filter((item) => (
                item.subdistrict.toLowerCase().replace(/\s+/g, '').includes(query.toLocaleLowerCase().replace(/\s+/g, '')
                )))


    return (
        <div className='flex flex-col w-full mt-1'>
            <span className='text-sm text-secondary mb-1'>{dictionary.filter.area}:</span>
            <Popover>
                {({ open, close }) => (
                    /* Use the `open` state to conditionally change the direction of the chevron icon. */
                    <>
                        <Popover.Button onClick={() => selectCheckedValues()} className='relative w-full py-2 pl-3 pr-10  border-[1px] border-forth rounded-lg text-sm flex items-center leading-5 text-gray-900 focus:ring-0'>
                            {selectedValues.length == 0 ? 'All Areas' : /*'Area Filter Active'*/ showAreas() }
                            <span className="absolute inset-y-0 right-0 flex items-center pr-2">
                                <RiArrowDropDownLine
                                    color={tailwindConfig.theme.extend.colors.secondary}
                                    size={28}
                                />
                            </span>
                            {/* <ChevronDownIcon className={open ? 'rotate-180 transform' : ''} /> */}
                        </Popover.Button>
                        <Popover.Overlay className="fixed inset-0 bg-secondary bg-opacity-50 !z-100" />
                        <div className='absolute left-0 right-0 top-16 md:px-2 px-2'>
                            <Popover.Panel className='md:w-[460px] w-full mx-auto bg-light text-secondary max-h-[600px] overflow-y-auto z-50 border-[1px] border-forth rounded-lg'>
                                <div className='w-full text-center my-2 z-[100]'>
                                    <span className='text-maincolor font-bold'>{dictionary.filter.selectedAreas}</span>
                                </div>
                                <div className='flex flex-row items-center w-full justify-between px-2'>
                                    <p className='px-4 font-semibold'>Pattaya Area:</p>
                                    <button className={`${selectedLocations.includes('Pattaya') ? 'bg-third' : 'bg-maincolor'} text-light py-1 px-2 rounded-md`} 
                                        onClick={() => {
                                            selectWholeArea('Pattaya')
                                            close()
                                        }}
                                    >{selectedLocations.includes('Pattaya') ? `${dictionary.filter.unselectAll}` : `${dictionary.filter.selectAll}`}</button>
                                </div>
                                {filteredDistrict.filter(district => district.location === 'Pattaya').map((district, index) => (
                                    <div key={district.id} className='py-2 px-4 cursor-pointer color-secondary z-50 flex flex-row items-center' >
                                        <input 
                                            className='mx-2'
                                            type="checkbox" 
                                            id={district.subdistrict} 
                                            name="districts" 
                                            defaultChecked={selectedValues?.includes(district.id)}
                                            // checked={selectedValues?.includes(district.id)}
                                            onChange={() => handleCheckboxChange(district.id)}
                                        />
                                        <label className='w-full' htmlFor={district.subdistrict}>{district.subdistrict}</label>
                                    </div>
                                ))}
                                {/* <div className='flex flex-row items-center w-full justify-between px-2'>
                                    <p className='px-4 font-semibold'>Bangkok Area:</p>
                                    <button 
                                        className={`${selectedLocations.includes('Bangkok') ? 'bg-third' : 'bg-maincolor'} text-light py-1 px-2 rounded-md`} 
                                        onClick={() => {
                                            selectWholeArea('Bangkok')
                                            close()
                                        }}
                                    >{selectedLocations.includes('Bangkok') ? `${dictionary.filter.unselectAll}` : `${dictionary.filter.selectAll}`}</button>
                                </div> */}
                                {filteredDistrict.filter(district => district.location === 'Bangkok').map((district, index) => (
                                    <div key={district.id} className='py-2 px-4 cursor-pointer color-secondary z-50 flex flex-row items-center' >
                                        <input 
                                            className='mx-2'
                                            type="checkbox" 
                                            id={district.subdistrict} 
                                            name="districts" 
                                            defaultChecked={selectedValues?.includes(district.id)}
                                            // checked={selectedValues?.includes(district.id)}
                                            onChange={() => handleCheckboxChange(district.id)}
                                        />
                                        <label htmlFor={district.subdistrict}>{district.subdistrict}</label>
                                    </div>
                                ))}
                                {/* <div className='flex flex-row items-center w-full justify-between px-2'>
                                    <p className='px-4 font-semibold'>Nakhon Si Thammarat Area:</p>
                                    <button 
                                        className={`${selectedLocations.includes('Nakhon Si Thammarat') ? 'bg-third' : 'bg-maincolor'} text-light py-1 px-2 rounded-md`} 
                                        onClick={() => {
                                            selectWholeArea('Nakhon Si Thammarat')
                                            close()
                                        }}
                                    >{selectedLocations.includes('Nakhon Si Thammarat') ? 'Unselect All' : 'Select All'}</button>
                                </div> */}
                                {/* {filteredDistrict.filter(district => district.location === 'Nakhon Si Thammarat').map((district, index) => (
                                    <div key={district.id} className='py-2 px-4 cursor-pointer color-secondary z-50 flex flex-row items-center' >
                                        <input 
                                            className='mx-2'
                                            type="checkbox" 
                                            id={district.subdistrict} 
                                            name="districts" 
                                            defaultChecked={selectedValues?.includes(district.id)}
                                            // checked={selectedValues?.includes(district.id)}
                                            onChange={() => handleCheckboxChange(district.id)}
                                        />
                                        <label htmlFor={district.subdistrict}>{district.subdistrict}</label>
                                    </div>
                                ))} */}
                            </Popover.Panel>
                        </div>
                    </>
                )}
            </Popover>
        </div >
    )
}

export default MultiDistrictFilter